import { StoreInterface } from '../../interfaces/interfaces';

import './styles.scss';


export function Store({ name, city, uf, cnpj, salesforce, ...props }: StoreInterface) {
  return (
    <button className="sale" {...props}>
     
        <div className="itens-container-store">
            <div className="itens-store iten-1">
              <span className="title">Nome:</span>
              {name}
            </div>
            <div className="itens-store iten-5">
              {salesforce}
            </div>
            <div className="itens-store iten-2">
              <span className="title">Cidade:</span>
              {city}
            </div>
            <div className="itens-store iten-3">
              <span className="title">UF:</span>
              {uf}
            </div>
            <div className="itens-store iten-4">
              <span className="title">CNPJ:</span>
              {cnpj}
            </div>
          
        </div>
   
    </button>
  );
}